import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2 justify-between w-full" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, /*#__PURE__*/_toDisplayString("Quiz"), -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!

  return (!_ctx.storeLoader.load[_ctx.ELoader.QUIZ] && _ctx.storeTrail.ableToQuiz)
    ? (_openBlock(), _createBlock(_component_Button, {
        key: 0,
        id: "quiz",
        class: _normalizeClass([
    'w-full !text-h-neutral-800 !rounded-b !rounded-t-none btn-light',
    _ctx.storeChapter.currentChapter!.done
      ? '!bg-green-100 !text-h-success-800'
      : 'btn-light',
  ]),
        onClick: _withModifiers(_ctx.storeQuiz.onShowQuiz, ["prevent"]),
        disabled: _ctx.storeChapter.currentChapter!.done || _ctx.storeLoader.load[4]
  
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                name: "hi-solid-check-circle",
                class: _normalizeClass([_ctx.storeChapter.currentChapter!.done ? 'text-green-500' : ''])
              }, null, 8, ["class"]),
              _hoisted_3
            ]),
            _createVNode(_component_v_icon, { name: "md-helpoutline" })
          ])
        ]),
        _: 1
      }, 8, ["class", "onClick", "disabled"]))
    : _createCommentVNode("", true)
}